export default "/img/bank-icons.png"